<script>
import GanttElastic from 'gantt-elastic';
import MainView from 'gantt-elastic/src/components/MainView.vue';
import Chart from 'gantt-elastic/src/components/Chart/Chart.vue';
import GanttTask from './GanttTask.vue';
import GanttTodayLine from './GanttTodayLine.vue';

const CustomChart = {
  ...Chart,
  components: {
    ...Chart.components,
    GanttTask,
    GanttTodayLine
  }
};

const CustomMainView = {
  ...MainView,
  components: {
    ...MainView.components,
    Chart: CustomChart
  }
};

export default {
  name: 'GanttElasticWrapper',
  extends: GanttElastic,
  components: {
    MainView: CustomMainView
  }
};
</script>
